"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _withIcon = _interopRequireDefault(require("./withIcon"));
const OptionClosePrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(6.000000, 6.000000)"
}, _react.default.createElement("path", {
  d: "M6,4.58578644 L10.2928932,0.292893219 C10.6834175,-0.0976310729 11.3165825,-0.0976310729 11.7071068,0.292893219 C12.0976311,0.683417511 12.0976311,1.31658249 11.7071068,1.70710678 L7.41421356,6 L11.7071068,10.2928932 C12.0976311,10.6834175 12.0976311,11.3165825 11.7071068,11.7071068 C11.3165825,12.0976311 10.6834175,12.0976311 10.2928932,11.7071068 L6,7.41421356 L1.70710678,11.7071068 C1.31658249,12.0976311 0.683417511,12.0976311 0.292893219,11.7071068 C-0.0976310729,11.3165825 -0.0976310729,10.6834175 0.292893219,10.2928932 L4.58578644,6 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L6,4.58578644 Z"
}))));
const OptionCloseMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 22 22"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M18.7071068,4 L19.4142136,4.70710678 L12.414,11.707 L19.4142136,18.7071068 L18.7071068,19.4142136 L11.707,12.414 L4.70710678,19.4142136 L4,18.7071068 L11,11.707 L4,4.70710678 L4.70710678,4 L11.707,11 L18.7071068,4 Z"
}));
const AbstractOptionClose = ({
  theme,
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(OptionCloseMDS, other) : _react.default.createElement(OptionClosePrizm, other);
var _default = exports.default = (0, _styledComponents.withTheme)((0, _withIcon.default)('OptionClose')(AbstractOptionClose));